import api from './api';
import types from './mutation-types';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setSelectedRow_({ commit }, { key, value }) {
		commit(types.SELECTED_ROW, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	/**call API */
	async getCommCodes_({ commit }, { key, codeType }, plantCd) {
		try {
			const { header, body } = await api.getCommCodes(codeType);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getList({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data.header.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async updateUnit_({ state }) {
		const { overSrgNo, occuQty, badSbc, badCause, badId } = state.selectedRow;
		const updatedRow = { overSrgNo, occuQty, badSbc, badCause, badId };
		try {
			const { header } = await api.updateUnit(updatedRow);
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async updatePartNo_({ state }) {
		const { overSrgNo, partNo } = state.selectedRow;
		const updatedRow = { overSrgNo, partNo };
		try {
			const { header } = await api.updatePartNo(updatedRow);
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async deleteOverSrgAltrList_({ state }, delRows) {
		try {
			const { header } = await api.deleteOverSrgAltrList(delRows);
			return header;
		} catch (error) {
			//return error.header || error;
			throw new Error(error.header.message || error);
		}
	}
	
};
